import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ChangePassword from '../../../ChangePassword/index';

export default () => (
  <Switch>
    <Route exact path="/changepassword" component={ChangePassword} />
  </Switch>
);